//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavLeadRouter(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 15L6 21H4L4 13L11 13V10.874C9.27477 10.43 8 8.86384 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7C16 8.86384 14.7252 10.43 13 10.874V13H20V15H6ZM14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9C13.1046 9 14 8.10457 14 7ZM11 21L11 17H13V21H11ZM18 21V17H20V21H18Z" fill="currentColor" /></svg>;
}
export default IconNavLeadRouter;